import NorbertGame from './common/NorbertGame';

const game = NorbertGame('#game');
game.start();
